<kodit-dropdown
  formCtrlId="vrsta-otpremnice"
  [ctrlDisabled]="(isDisabled || jeKonvertovanje)"
  [options]="items"
  ctrlTooltip="Izaberite vrstu otpremnice"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
  (optionChanged)="handleVrstaChanged($event)"
></kodit-dropdown>
